import React, {ReactNode} from "react";
import {
  Box,
  CardActions,
  Grid,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import clsx from "clsx";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

interface ExpandedTitleProps {
  title: string | ReactNode;
  expanded: boolean;
  loading?: boolean;
  withPadding?: boolean;
  withBorder?: boolean;

  handleExpandClick: () => void;
}

const useStyles = makeStyles(
  (theme) => ({
    titleSectionWrapper: {
      borderTop: (props: ExpandedTitleProps) => props.withBorder ? "1px solid #e8e8e8" : "none",
      cursor: (props: ExpandedTitleProps) =>
        props.loading ? "default" : "pointer",

      paddingLeft: (props: ExpandedTitleProps) => props.withPadding ? theme.spacing(3) : 0,
      paddingRight: (props: ExpandedTitleProps) => props.withPadding ? theme.spacing(1) : 0,
    },

    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
    },

    expandOpen: {
      transform: "rotate(180deg)",
    },

    titleSection: {
      fontSize: 15,
    },
  }),
  { name: "expanded-title-styles" }
);

export default function ExpandedTitle(props: ExpandedTitleProps) {
  const classes = useStyles(props);
  // Props
  const { title, expanded, handleExpandClick } = props;

  const handleClick = (event: any) => {
    handleExpandClick();
  };

  return (
    <Grid
      className={classes.titleSectionWrapper}
      container
      onClick={handleClick}
    >
      <Grid item xs={12}>
        <CardActions disableSpacing>
          <Box
            className={classes.titleSection}
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
          >
            {title}
          </Box>
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={handleClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
      </Grid>
    </Grid>
  );
}

ExpandedTitle.defaultProps = {
  loading: false,
  withPadding: true,
  withBorder: true,
};
